export function formatCsvBlob(data: string) {
  // create a blob object, and add byte-order-mark (BOM) to specify UTF-8 in Excel
  // as it doesn't seem to understand charset=utf-8
  // https://stackoverflow.com/a/61670918
  const BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  const blob = new Blob([BOM, data], { type: "text/csv;charset=utf-8" });
  return blob;
}
